export default __webpack_public_path__ + "static/media/oneclick-light.72d4f0f6.webp";